<script setup lang="ts">
import MessageList from "@/components/message/MessageList.vue";
import MessageEditor from "@/components/message/MessageEditor.vue";
import { ref } from "vue";

const web = ref<typeof MessageList | null>(null);
const ios = ref<typeof MessageList | null>(null);
const android = ref<typeof MessageList | null>(null);
const refresh = (platforms: string[]) => {
  if (platforms && web.value && platforms.includes("web")) web.value.refresh();
  if (platforms && ios.value && platforms.includes("ios")) ios.value.refresh();
  if (platforms && android.value && platforms.includes("android"))
    android.value.refresh();
};
</script>

<template>
  <h1>Broadcast messages</h1>

  <section id="web">
    <MessageList ref="web" platform="web" />
  </section>

  <section id="ios">
    <MessageList ref="ios" platform="ios" />
  </section>

  <section id="android">
    <MessageList ref="android" platform="android" />
  </section>

  <section>
    <MessageEditor @refresh="refresh" />
  </section>
</template>
<style lang="scss" scoped>
.separator {
  height: 3rem;
}
</style>
